import { db } from '@/firebase/init'
import { collection, doc } from 'firebase/firestore'

export const setIDOnCreate = (id: string, myCollection: string) => {
  if (id) {
    return id
  }

  const docRef = doc(collection(db, myCollection))
  return docRef.id
}

export function lockBodyScroll() {
  const body = document.body
  const html = document.documentElement

  // Prevent layout jump when hiding scrollbar
  const scrollbarWidth = window.innerWidth - html.clientWidth

  body.dataset.__modalScrollLocked = '1'
  body.style.overflow = 'hidden'
  if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`
}

export function unlockBodyScroll() {
  const body = document.body
  delete body.dataset.__modalScrollLocked
  body.style.overflow = ''
  body.style.paddingRight = ''
}
